import * as DictionaryConstants from "../../../../../../constants/DictionaryConstants";
import * as RoutePathConstants from "../../../../../../constants/RoutePathConstants";
import { mapActions, mapState } from "vuex";
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from "moment";

export default {
  data () {
    return {
      pageNum: 1,
      pageSize: 10,
      pageOrder: "desc",
      pageSort: "id",
      centerHeight: document.documentElement.clientHeight - 130 + "px",
      type: "0",
      activeIndex: "1000",
      key: 1000
    };
  },
  computed: {
    ...mapState("recordsOfConsumptionModule", ["myMemberConsumption"]),
    myMemberConsumptionInfo () {
      return this.myMemberConsumption;
    }
  },
  methods: {
    ...mapActions("recordsOfConsumptionModule", ["getMemberConsumption"]),
    dateFormat (time) {
      return time ? moment(time).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    handleSelect (key, keyPath) {
      this.key = key;
    }
  },
  mounted () { },
};



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/page-mail-my/views/coupon/coupon.js